// extracted by mini-css-extract-plugin
export var body = "_404-module--body--Rkhuk";